/**
 * Defines a collection of Device Invite Request
 */
import Backbone from 'backbone';

import DeviceInviteRequest from 'models/device/DeviceInviteRequest';

var PendingDeviceInviteRequests = Backbone.Collection.extend({
    model: DeviceInviteRequest,

    backend: 'gcapi',

    url: function() {
        return '/invite-service/invite';
    }
});

export default PendingDeviceInviteRequests;
